import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stop_play",
  "use": "icon-stop_play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stop_play\"><path d=\"M331.52 217.6c21.12 0 38.4 17.28 38.4 38.4v512c0 21.12-17.28 38.4-38.4 38.4s-38.4-17.28-38.4-38.4V256c0-21.12 17.28-38.4 38.4-38.4z m360.96 0c21.12 0 38.4 17.28 38.4 38.4v512c0 21.12-17.28 38.4-38.4 38.4-21.12 0-38.4-17.28-38.4-38.4V256c0-21.12 17.28-38.4 38.4-38.4z\" p-id=\"8995\" fill=\"#FB6C28\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol